import { render } from "./AnalysisSidebar.vue?vue&type=template&id=60dc4bf2&scoped=true"
import script from "./AnalysisSidebar.vue?vue&type=script&lang=js"
export * from "./AnalysisSidebar.vue?vue&type=script&lang=js"

import "./AnalysisSidebar.vue?vue&type=style&index=0&id=60dc4bf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dc4bf2"]])

export default __exports__